"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.svdVersionReducer = void 0;
const svdVersion_1 = require("../actions/svdVersion");
const svdVersionReducer = (version = svdVersion_1.PENDING_SVD_VERSION, action) => {
    return action.type === svdVersion_1.SET_SVD_VERSION ? action.payload : version;
};
exports.svdVersionReducer = svdVersionReducer;
//# sourceMappingURL=svdVersion.reducer.js.map